module.exports = __webpack_public_path__ + "static/media/info-icon-green.686e5bae.svg";